<template>
<div class="votingpage" >
    <section class="poll-wrapper" style="padding-bottom: 40px;">
        <div class="choices-wrapper" >
          <div v-for="(token, index) in tokens" :key="index" :class="['poll-item', 'ch' + (index + 1), {'is--winner': winnerIndex === index}]">
            <div class="blob-amount" :style="{ transform: `scale(1, ${normalizedResults[index]})` }">
            </div>
            <h1 class="token-name">{{ token.symbol }}</h1>
            <div class="item-details">
              <img class="token-logo" :src="require(`@/assets/img/ranking/${token.symbol}-logo.png`)" style=" margin: 5% auto;"/>
              <h3 class="token-vote">{{ token.totalVotes }} {{ $t('lang.votes') }}</h3>
            </div>
            <div class="item-description">
              <h1 class="heading-xl">{{ $t(`lang.${token.symbol}Header`) }}</h1>
            </div>
            <div class="item-btn">
              <div v-if="user && !user.votedFor" class="btn vote" @click="selectVote(token.symbol)">{{ $t('lang.Vote') }}</div>
              <div v-else class="btn vote" style="cursor: not-allowed;"><span style="text-decoration: line-through">{{ $t('lang.Vote') }}</span></div>
            </div>
            <div class="item-btn">
              <div class="btn vote" @click="scrollTo(`${token.symbol}-banner`)">{{ $t('lang.detail') }}</div>
            </div>
          </div>
        </div>
    </section>

  <!-- Conflux banner -->
  <partnerBanner
      id="CFX-banner"
      :title="$t('lang.confluxNetwork')"
      :logoSrc="require('@/assets/img/ranking/CFX-logo.png')"
      :description="$t('lang.confluxDesc')"
      :buttonText="$t('lang.exploreConflux')"
      websiteUrl="https://confluxnetwork.org/"
      bannerBackground="linear-gradient(135deg, rgba(0,50,200,0.5), rgba(0,150,250,0.5))"
      :isWorking="true"
      :widgets="[
        [
          { title: $t('lang.cfxPrice'), content: `CFX` },
          { title: $t('lang.tps'), content: $t('lang.upTo6000TPS') }
        ],
        [
          { title: $t('lang.consensusModel'), content: $t('lang.treeGraphPoW') },
          { title: $t('lang.regulatoryStatus'), content: $t('lang.chinaCompliant') }
        ],
        [
          { title: $t('lang.whyChooseConflux'), items: [$t('lang.fast'), $t('lang.lowFees'), $t('lang.multiChain'), $t('lang.compliant')] },
          { title: $t('lang.benefitsForREVO'), items: [$t('lang.expansion'), $t('lang.faster'), $t('lang.lowerFees'), $t('lang.adoption')] }
        ]
      ]"
  />

  <!-- GSC Banner -->
  <partnerBanner
      id="GSC-banner"
      :title="$t('lang.gsc')"
      :logoSrc="require('@/assets/img/ranking/GSC-logo.png')"
      :description="$t('lang.gscDesc')"
      :buttonText="$t('lang.exploreGSC')"
      websiteUrl="https://www.gsc.social/"
      bannerBackground="linear-gradient(135deg, rgba(230,80,100,0.5), rgba(255,130,60,0.5))"
      :isWorking="false"
      :widgets="[
        [
          { title: $t('lang.gscToken'), content: 'GSC' },
          { title: $t('lang.tps'), content: $t('lang.1000TPS') }
        ],
        [
          { title: $t('lang.consensusModel'), content: $t('lang.dposBft') },
          { title: $t('lang.primaryUseCase'), content: $t('lang.decentralizedSocialMedia') }
        ],
        [
          { title: $t('lang.whyChooseGSC'), items: [$t('lang.privacyFirst'), $t('lang.userOwnedData'), $t('lang.highEfficiency'), $t('lang.socialIntegration')] },
          { title: $t('lang.benefitsForREVO'), items: [$t('lang.globalCommunity'), $t('lang.decentralizedID'), $t('lang.highThroughput'), $t('lang.enhancedAdoption')] }
        ]
      ]"
  />

  <!-- OORT Banner -->
  <partnerBanner
      id="OORT-banner"
      :title="$t('lang.oort')"
      :logoSrc="require('@/assets/img/ranking/OORT-logo.png')"
      :description="$t('lang.oortDesc')"
      :buttonText="$t('lang.exploreOORT')"
      websiteUrl="https://www.oortech.com/"
      bannerBackground="linear-gradient(135deg, rgba(0,140,120,0.5), rgba(0,200,170,0.5))"
      :isWorking="false"
      :widgets="[
        [
          { title: $t('lang.oortToken'), content: 'OORT' },
          { title: $t('lang.computePower'), content: $t('lang.decentralizedGpuNetwork') }
        ],
        [
          { title: $t('lang.infrastructure'), content: $t('lang.aiCloudComputing') },
          { title: $t('lang.consensusModel'), content: $t('lang.posBased') }
        ],
        [
          { title: $t('lang.whyChooseOort'), items: [$t('lang.aiOptimized'), $t('lang.decentralizedStorage'), $t('lang.securityFocused'), $t('lang.globalNodes')] },
          { title: $t('lang.benefitsForREVO'), items: [$t('lang.fasterAi'), $t('lang.costReduction'), $t('lang.scalableSolutions'), $t('lang.interoperability')] }
        ]
      ]"
  />

  <!-- Chain33 banner -->
  <partnerBanner
      id="BTY-banner"
      :title="$t('lang.bityuan')"
      :logoSrc="require('@/assets/img/ranking/BTY-logo.png')"
      :description="$t('lang.chain33Desc')"
      :buttonText="$t('lang.exploreChain33')"
      websiteUrl="https://chain.33.cn/"
      bannerBackground="linear-gradient(135deg, rgba(100,100,255,0.5), rgba(120,0,255,0.5))"
      :isWorking="false"
      :widgets="[
        [
          { title: $t('lang.btyPrice'), content: 'BTY' },
          { title: $t('lang.transactionCapability'), content: $t('lang.3000TPS') }
        ],
        [
          { title: $t('lang.consensusAlgorithm'), content: $t('lang.dpos') },
          { title: $t('lang.applicableField'), content: $t('lang.enterpriseBlockchain') }
        ],
        [
          { title: $t('lang.whyChooseChain33'), items: [$t('lang.security'), $t('lang.modular'), $t('lang.compatible'), $t('lang.highThroughput')] },
          { title: $t('lang.benefitsForREVO'), items: [$t('lang.enterpriseService'), $t('lang.developmentEfficiency'), $t('lang.chainSecurity'), $t('lang.scalability')] }
        ]
      ]"
  />

    <div id="modalExit" class="modal-exit">
        <div class="modal-exit-content">
            <div id="modal-exit-title" class="modal-exit-title">
            {{ $t('lang.Vote') }} {{ this.symbol }} ?
            </div>
            <div id="modal-exit-desc" class="modal-exit-desc">
            </div>
        </div>
        <div class="modal-exit-button" v-on:click="closeModal">
          {{ $t('lang.Cancel') }}
        </div>
        <div id="modalConfirm" class="modal-exit-button" v-on:click="vote">
            {{ user ? user.votedFor ? 'Close' : 'Vote' : 'Close' }}
        </div>
    </div>
</div>
</template>

<script>
import request from "@/services/request";
import detail from "@/views/ranking/detail.vue";
import partnerBanner from "@/views/ranking/partnerBanner.vue";
export default {
    components: {
      partnerBanner,
        detail,
    },
    data() {
        return {
            user: null,
          tokens: [
            {
              "name": "GSC公链",
              "symbol": "GSC",
              "totalVotes": 0,
              "percent": 0,
            },
            {
              "name": "OORT公链",
              "symbol": "OORT",
              "totalVotes": 0,
              "percent": 0,
            },
            {
              "name": "CFX公链",
              "symbol": "CFX",
              "totalVotes": 0,
              "percent": 0,
            },
            {
              "name": "BTY公链",
              "symbol": "BTY",
              "totalVotes": 0,
              "percent": 0,
            }
          ],
            tokensSorted: [],
            lang: "",
            symbol: "",
            winnerIndex: null,
            detailsOpen: false,
            votedIndex: null,
        }
    },
    created() {
        this.lang = sessionStorage.getItem("Language");
        this.getUser();
        this.getTokens();
    },
    computed: {
        totalVotes() {
            return this.tokens.map(token => token.totalVotes);
        },
        normalizedResults() {
            const maxVotes = Math.max(...this.totalVotes);
            return this.totalVotes.map(vote => maxVotes > 0 ? (vote / maxVotes * 0.7 + 0.2) : 0.2);
        }
    },
    methods: {
        scrollTo(bannerId) {
          const el = document.getElementById(bannerId);
          if(el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        },
        getUser() {
          request.getVotingUser().then((res) => {
            console.log(res)
            this.user = res;
          }).catch(error => {
              console.log(error);
              this.register();
          });
        },
        register() {
            request.register().then((res) => {
                this.user = res;
            }).catch(error => {
                console.log(error);
            });
        },

        selectVote(symbol) {
            this.symbol = symbol;
            this.displayModal();
        },
        vote() {
          if (!this.user || this.user.votedFor) return this.closeModal();
          let parma = {
              symbol: this.symbol
          };
          request.vote(parma).then((res)=> {
              this.user = res
              this.getTokens();
              this.getUser();
              this.closeModal();
              document.getElementById(`leaderboard`)?.scrollIntoView({ behavior: 'smooth', block: 'end' });
          })
        },
        handleClick(symbol){
            const links = {
                GSC:'https://www.gsc.social/',
                OORT:'https://www.oortech.com/',
                CFX:'https://confluxnetwork.org/',
                BTY:'https://bityuan.com/'}
            if(links[symbol]){
                window.open(links[symbol]);
            }
        },
        showResults() {
            this.results = this.contestants.map(value => parseInt(value));
            this.winnerIndex = this.results.indexOf(Math.max(...this.results));
            document.querySelectorAll('.vote').forEach(el => el.classList.add('results-r-in'));
        },
        scrollToSection(index) {
            document.getElementById(`section-${index}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        },
        displayModal() {
            console.log(this.$t.vote)
            document.getElementById('modal-exit-title').innerText = this.user && !this.user.votedFor ? `${this.$t('lang.Vote')} ${ this.symbol } ?` : this.$t('lang.prohibited');
            document.getElementById('modalConfirm').innerText = this.user && !this.user.votedFor ? this.$t('lang.Vote') : this.$t('lang.Close');
            document.getElementById('modal-exit-desc').innerText = !this.user ? this.$t('lang.mint1Nft') : this.user.votedFor ? `${this.$t('lang.voted')} ${this.user.votedFor}` : `${this.$t('lang.confirmVote')} ${this.symbol}`;
            document.getElementById('modalExit').style.visibility = "visible";
        },
        closeModal() {
            document.getElementById('modalExit').style.visibility = "hidden";
            this.symbol = "";
        }
    }
}
</script>

<style lang='less' scoped>
.votingpage {
  scroll-behavior: smooth;
  width: 100%;
}
html,
body {
  width: 100%;
  height: 100%;
}

section {
  width: 100%;
  height: 100%;
  min-height: 100%;
}

* {
  box-sizing: border-box;
}

#ltmWrapper {
  width: 100%;
  height: 100%;
}

[class*=ltm-] {
  fill: #fff;
}

nav {
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-between;
  z-index: 5;
  font-family: "Roboto", sans-serif;
  transition: 335ms cubic-bezier(0.4, 0, 0.2, 1) all;
  padding: 10px;
}
nav .nav-logo {
  width: 200px;
  height: 40px;
}
nav .nav-logo:hover svg {
  fill: #333;
}
nav .nav-logo svg {
  overflow: visible;
  width: 100%;
  height: 100%;
}
nav .nav-logo svg * {
  width: 100%;
  height: 100%;
}
.choices-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.choices-wrapper .poll-item {
  margin-top: 20px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 400px;
  min-height: 400px;
  text-align: center;
  padding: 15px;
  color: #000;
  overflow: hidden;
  transition: 225ms cubic-bezier(0.4, 0, 0.2, 1) all;
  flex: 1;
  border-radius: 30px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
  0 6px 2px 0 rgba(0, 0, 0, 0.1);
}



.choices-wrapper .poll-item:hover {
  flex: 2;
}
.choices-wrapper .poll-item:hover button {
  transform: translatex(-50%) translatey(0%);
  opacity: 1;
}
.choices-wrapper .poll-item.is--winner:after {
  display: block;
  -webkit-animation: fadeout 1100ms cubic-bezier(0.4, 0, 0.2, 1) forwards 1000ms;
          animation: fadeout 1100ms cubic-bezier(0.4, 0, 0.2, 1) forwards 1000ms;
}
.choices-wrapper .poll-item:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  mix-blend-mode: soft-light;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 0;
}
.choices-wrapper .poll-item:after {
  display: none;
  content: "";
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7);
  opacity: 0;
  transition: 450ms cubic-bezier(0.4, 0, 0.2, 1) all;
  z-index: 2;
}
.choices-wrapper .poll-item .blob-amount {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  transform: scale(1, 0);
  transform-origin: bottom center;
  transition: 1000ms cubic-bezier(0.4, 0, 0.2, 1) transform;
}
.choices-wrapper .poll-item.ch1 {
  background-color: rgba(235, 84, 57, 0.2);
}
.choices-wrapper .poll-item.ch1:before {
  //background-image: url(../image/601.jpg);
}
.choices-wrapper .poll-item.ch1 .vote {
  color: #EB5439;
  box-shadow: 0 2px 4px rgba(173, 41, 17, 0.6);
}
.choices-wrapper .poll-item.ch1 .vote:hover {
  box-shadow: 0 10px 20px rgba(173, 41, 17, 0.6);
}
.choices-wrapper .poll-item.ch1 .expand-btn:hover {
  color: #EB5439;
}
.choices-wrapper .poll-item.ch2 {
  background-color: rgba(1, 161, 161, 0.2);
}
.choices-wrapper .poll-item.ch2:before {
  //background-image: url(../image/603.jpg);
}
.choices-wrapper .poll-item.ch2 .vote {
  color: #01A1A1;
  box-shadow: 0 2px 4px rgba(0, 60, 60, 0.6);
}
.choices-wrapper .poll-item.ch2 .vote:hover {
  box-shadow: 0 10px 20px rgba(0, 60, 60, 0.6);
}
.choices-wrapper .poll-item.ch2 .expand-btn:hover {
  color: #01A1A1;
}
.choices-wrapper .poll-item.ch3 {
  background-color: rgba(46, 61, 216, 0.2);
}
.choices-wrapper .poll-item.ch3:before {
  //background-image: url(../image/602.jpg);
}
.choices-wrapper .poll-item.ch3 .vote {
  color: #2E3DD8;
  box-shadow: 0 2px 4px rgba(25, 35, 135, 0.6);
}
.choices-wrapper .poll-item.ch3 .vote:hover {
  box-shadow: 0 10px 20px rgba(25, 35, 135, 0.6);
}
.choices-wrapper .poll-item.ch3 .expand-btn:hover {
  color: #2E3DD8;
}
.choices-wrapper .poll-item.ch4 {
  background-color: rgba(115, 116, 134, 0.2);
}
.choices-wrapper .poll-item.ch4:before {
  //background-image: url(../image/604.jpg);
}
.choices-wrapper .poll-item.ch4 .vote {
  color: #737486;
  box-shadow: 0 2px 4px rgba(68, 68, 79, 0.6);
}
.choices-wrapper .poll-item.ch4 .vote:hover {
  box-shadow: 0 10px 20px rgba(68, 68, 79, 0.6);
}
.choices-wrapper .poll-item.ch4 .expand-btn:hover {
  color: #737486;
}
.choices-wrapper .poll-item {
  margin-top: 20px;
  .token-name{
    position: absolute;
    top: 3%;
    left: 10%;
    width: 80%;
    font-size: 2rem;
    text-align: left;
    color: black;
  }
  .item-details {
    position: absolute;
    top: 10%;
    width: 80%;
    height: 45%;
    left: 10%;
    background: linear-gradient(45deg, rgba(218,107,255,0.5), rgba(243,231,91,0.5), rgba(74,226,213,0.5));
    z-index: 2;
    border-radius: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .token-logo {
      object-fit: contain;
      width: 60%;
      height: 60%;
    }
    .token-vote{
      position: absolute;
      bottom: 5%;
      width: 100%;
    }
  }
  .item-description{
    position: relative;
    width: 80%;
    top: 50px;
    color: black;
  }
  .item-btn{
    position: absolute;
    width: 100%;
    bottom: 2%;
  }
  .item-btn:last-child{
    bottom: calc(10px + 60px);
  }
}

.poll-details {
  position: relative;
  transition: 335ms cubic-bezier(0.4, 0, 0.2, 1) all;
  z-index: 4;
  background-color: #fff;
  padding: 20px;
  padding-top: 75px;
}
.poll-details.open {
  transform: translatey(-100%);
}
.poll-details .close-panel {
  cursor: pointer;
  position: absolute;
  top: 55px;
  left: 50%;
}

.btn {
  -webkit-user-select: none;
  -moz-user-select: none;
   -ms-user-select: none;
       user-select: none;
  cursor: pointer;
  background: #fff;
  border-radius: 25px;
  line-height: 50px;
  height: 50px;
  transition: 335ms cubic-bezier(0.4, 0, 0.2, 1) all;
  outline: none;
  border: none;
  padding: 0 10px;
}
.btn + .btn {
  margin-left: 10px;
}

.vote {
  position: relative;
  margin: 0 auto;
  margin-top: 50px;
  width: 100px;
  transition: 225ms cubic-bezier(0.4, 0, 0.2, 1) transform 420ms, 335ms cubic-bezier(0.4, 0, 0.2, 1) width, 225ms cubic-bezier(0.4, 0, 0.2, 1) color, 335ms cubic-bezier(0.4, 0, 0.2, 1) box-shadow;
}
.vote.results-r-in {
  color: transparent !important;
  width: 30px;
  transform: scale(0);
}
.vote .click-voted {
  position: absolute;
  bottom: 100%;
  left: 0;
  width: 100%;
  text-align: center;
  color: #fff;
  -webkit-animation: plusone 555ms cubic-bezier(0.4, 0, 0.2, 1) forwards;
          animation: plusone 555ms cubic-bezier(0.4, 0, 0.2, 1) forwards;
}

.expand-btn {
  position: absolute;
  bottom: 10%;
  left: 50%;
  transform: translatex(-50%) translatey(100%);
  background: none;
  width: 100%;
  max-width: 100px;
  line-height: 27px;
  color: #fff;
  border: 2px solid #fff;
  opacity: 0;
}
.expand-btn:hover {
  background-color: #fff;
}

@-webkit-keyframes wave {
  0% {
    transform: translate3d(0, 0, 0);
  }
  50% {
    transform: translate3d(50%, 0.5em, 0);
  }
  100% {
    transform: translate3d(100%, 0, 0);
  }
}

@keyframes wave {
  0% {
    transform: translate3d(0, 0, 0);
  }
  50% {
    transform: translate3d(50%, 0.5em, 0);
  }
  100% {
    transform: translate3d(100%, 0, 0);
  }
}
@-webkit-keyframes fadeout {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@keyframes fadeout {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@-webkit-keyframes plusone {
  to {
    transform: translateY(-50%);
    opacity: 0;
  }
}
@keyframes plusone {
  to {
    transform: translateY(-50%);
    opacity: 0;
  }
}





.modal-exit {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

  background-color: #f2f2f2;
  border-radius: 4px;
  border: 1px solid #dcdcdc;
  box-shadow: 0px 0px 72px rgba(0, 0, 0, 0.18);
  box-sizing: border-box;
  color: #484848;
  display: inline-block;
  width: 360px;
  transition: transform 0.14s, opacity 0.14s ease-in-out;
  visibility: hidden;
  z-index: 10;
}

.modal-exit-content {
  padding: 24px;
  height: 140px;
  text-align: center;
}

.modal-exit-title {
 -webkit-font-smoothing: antialiased;
  font-size: 1rem;
  font-weight: 600;
  margin-top: 1rem;
  letter-spacing: 0.1em;
  padding-bottom: 12px;
  text-transform: uppercase;
}

.modal-exit-desc {
 -webkit-font-smoothing: antialiased;
  font-size: 0.9em;
  font-weight: 400;
  letter-spacing: 0.04em;
  line-height: 1.6;
}

.modal-exit-button {
  -webkit-font-smoothing: antialiased;
  border-right: 1px solid #dcdcdc;
  border-top: 1px solid #dcdcdc;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block;
  float: left;
  font-size: .7em;
  font-weight: 600;
  letter-spacing: .09em;
  padding: 18px;
  text-align: center;
  text-transform: uppercase;
  transition: background-color 0.14s, color 0.14s ease-in-out;
  width: 50%;
}

.modal-exit-button:last-child {
  border-right: none;
}

.modal-exit-button:hover {
  background-color: #fff;
  color: #121212;
}





.text-container {
    position: relative;
    box-sizing: border-box;
    margin: 0;

    padding: 10vh 10vw;
    text-align: center;
    .text-block {
        width: fit-content;
        margin: auto;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        h5 {
            font-size: 2.5rem;
            margin: 0;
        }
    }
  }
</style>